const DigitalPrinting = () => {
  return (
    <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Digital Printing
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                TCS is proud to be Pakistan’s fastest digital transactional printing facility, offering an end-to-end mail 
                management solution (MMS) and managed print solutions (MPS), covering all aspects of print and bulk 
                distribution, including designing and variable data printing and auto-duplexing.
              </p>
              
                
            </div>
            <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/MMs/digitalprinting.jpg" alt="" className="max-w-[100%] rounded-md"/>
            </div>
          </div>
            
        </div>
      </div>
  );
};

export default DigitalPrinting;